/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The station's access type:
 *   * PRIVATE:
 *   * PUBLIC:
 *   * PUBLIC_WITH_RESTRICTIONS:
 *   * RESIDENTIAL:
 *   * SHOPPING_CENTER:
 */
export enum AccessType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  PUBLIC_WITH_RESTRICTIONS = 'PUBLIC_WITH_RESTRICTIONS',
  RESIDENTIAL = 'RESIDENTIAL',
  SHOPPING_CENTER = 'SHOPPING_CENTER'
}
